module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bq-6e5b96f6104d2ff9977a1eb9e5c73272.svg";